import React from "react";
import { formatarData } from "../../../../components/Formatters/DateTime";

const LiminarLiberacaoCard = ({ liminarLiberacao }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>Liberações temporárias por liminar ou de ofício</b>
      </div>
      <div className="card-body">
        {" "}
        <center>
          <table className="table table-striped table-bordered" width="80%">
            <thead>
              <tr>
                <th>
                  <center>Nº DO PROCESSO JUDICIAL</center>
                </th>
                <th>
                  <center>DESCRIÇÃO DA LIBERAÇÃO</center>
                </th>
                <th>
                  <center>DATA INÍCIO</center>
                </th>
                <th>
                  <center>DATA FINAL</center>
                </th>
                <th>
                  <center>ABRANGÊNCIA</center>
                </th>
              </tr>
            </thead>
            <tbody>
              {liminarLiberacao?.map((liminar) => (
                <tr>
                  <td>
                    <center>{liminar.nuProcessoJudicial}</center>
                  </td>
                  <td>{liminar.descricao}</td>
                  <td>{formatarData(liminar.dataInicio, "dd/MM/yyyy")}</td>
                  <td>{formatarData(liminar.dataFim, "dd/MM/yyyy")}</td>
                  <td>{liminar.descricaoAbrangencia}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </center>
      </div>
    </div>
  </div>
);

export default LiminarLiberacaoCard;
